import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-commission',
  templateUrl: './dialog-commission.component.html',
  styleUrls: ['./dialog-commission.component.scss'],
})
export class DialogCommissionComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data) {}
}
